import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import React from 'react'

const CustomAccordian = ({ expandIcon, title, children }) => {
    return (
        <Accordion
            sx={{
                backgroundColor: "transparent",
                boxShadow: 0,
                color: "white",
                minHeight: 0,
                margin: 0,
                '&.Mui-expanded': {
                    minHeight: 0,
                    margin:0
                },
            }}
        >
            <AccordionSummary
                sx={{
                    padding: 0,
                    margin: 0,
                    fontWeight: 600,
                    minHeight: 0,
                    '&.Mui-expanded': {
                        minHeight: 0,
                        margin: 0
                    },
                    "& .MuiAccordionSummary-content": {
                        margin: '10px 0'
                    },
                    "& .MuiAccordionSummary-content.Mui-expanded": {
                        margin: '0px 0'
                    },
                }}
                expandIcon={expandIcon}
                aria-controls="panel1-content"
                id="panel1-header"
            >
                {title}
            </AccordionSummary>
            <AccordionDetails>
                <div className="root-dashboard-sidebar-my-plan-links">
                    {children}
                </div>
            </AccordionDetails>
        </Accordion>
    );
}

export default CustomAccordian